export default "__VITE_ASSET__Bwg51TBw__"